import { useCallback } from 'react';
import { useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { createTariffBook } from 'features/buku-tarif/shared/api/createTariffBook';
import { tariffBookKeys } from 'features/buku-tarif/shared/api/queryKeys';
import { useRetryableAction } from 'shared/hooks/useRetryableAction';
import { getErrorMessage } from 'shared/utils/errorMessage';
import { showErrorToastWithRetry } from 'shared/utils/showErrorToastWithRetry';

export const useCreateTariffBook = () => {
  const queryClient = useQueryClient();

  const { execute, isLoading } = useRetryableAction(
    (payload) => createTariffBook(payload),
    {
      onError: (error, { isRetryExhausted, status }) => {
        const message = getErrorMessage(error);
        if (status >= 500 && isRetryExhausted) {
          showErrorToastWithRetry(`Create tariff book: ${message}`, () =>
            execute()
          );
        } else {
          toast.error(`Create tariff book: ${message}`);
        }
      },
    }
  );

  const handleCreate = useCallback(
    async (payload) => {
      const result = await execute(payload);
      if (result) {
        queryClient.invalidateQueries(tariffBookKeys.all);
      }
      return result;
    },
    [execute, queryClient]
  );

  return { handleCreate, loading: isLoading };
};
